import React, { createContext, useReducer, useEffect, useState, useContext } from "react";
import { SocketReducers } from '../reducers/SocketReducers'
import mqtt from 'mqtt/dist/mqtt';
import { quitarTildes } from "../../utils/utils";
import { UserContext } from "./UserProvider";

export const SocketContext = createContext();

export function SocketProvider(props) {
    const [ subscription, setSubscription ] = useState([]);
    const { stateUser } = useContext(UserContext)
    const initialState = {
        connectStatus: localStorage.getItem('connect-status') || 'Connect',
        client: false, //JSON.parse(localStorage.getItem('client')) || false,
        isSubed: false,
        payload: {}
    }

    const [ state, dispatch ] = useReducer(SocketReducers, initialState);

    useEffect(() => {
        if (state.connectStatus === 'Connected' || state.connectStatus === 'Reconnecting') {
            mqttConnect(stateUser)
        }
    }, [])

    useEffect(() => {
        localStorage.setItem('connect-status', state.connectStatus);
    }, [state.connectStatus]);

    useEffect(() => {
        if (state.client) {
            state.client.on('connect', () => {
                dispatch({ type: 'setConnectStatus', payload: 'Connected' });
            });

            state.client.on('error', (err) => {
                console.error('Connection error: ', err);
                state.client.end();
            });

            state.client.on('reconnect', () => {
                dispatch({ type: 'setConnectStatus', payload: 'Reconnecting' });
                setTimeout(() => {
                    // mqttConnect()
                }, 5000)
            });

            state.client.on('message', (topic, message) => {
                const payload = { topic, message: JSON.parse(message.toString()) };
                dispatch({ type: 'setPayload', payload: payload });
            });
        }
    }, [state.client]);

    useEffect(() => {
        if (subscription) {
            mqttSub(subscription)
        }
    }, [subscription])

    const mqttConnect = (data) => {
        const host = process.env.REACT_APP_MQTT_HOST;
        // const port = process.env.REACT_APP_MQTT_PORT;
        // const protocol = process.env.REACT_APP_MQTT_PROTOCOL;
        // const url = `${protocol}://${host}:${port}/mqtt`
        // const area = data.nomArea ? (quitarTildes(data.nomArea)).replaceAll(' ','') :  ''
        // const user = data.nomUsuario||''
        // const codEmpresa = data.codEmpresa||0
        // const company = (codEmpresa).toString().padStart(5,'0')
        // const options = {
        //     keepalive: 30,
        //     protocolId: 'MQTT',
        //     protocolVersion: 4,
        //     clean: true,
        //     reconnectPeriod: 1000,
        //     connectTimeout: 30 * 1000,
        //     rejectUnauthorized: false,
        //     username: 'admin',
        //     password: 'admin'
        // };
        
        // options.clientId = `plamin.+ ${Math.random().toString(16).substr(2, 8)}`;

        // const userTopic = `ABX/WEB/XPROJECT/${user.split('@')[0].toUpperCase()}`;
        // const areaTopic = `ABX/WEB/XPROJECT/${(area).toUpperCase()}/RQ`;
        // const empresaTopic = `ABX/WEB/${company}/XPROJECT/RQ`;
        // dispatch({ type: 'setConnectStatus', payload: 'Connecting' });
        // const newClient = mqtt.connect(url, options);

        // dispatch({ type: 'setClient', payload: newClient});
        // setSubscription([
        //     {topic: areaTopic, qos: 0},
        //     {topic: userTopic, qos: 0},
        //     {topic: empresaTopic, qos: 0}
        // ])
    }

    const mqttDisconnect = () => {
        if (state.client) {
            state.client.end(() => {
                dispatch({ type: 'setConnectStatus', payload: 'Disconnect' });
                setSubscription([])
                dispatch({ type: 'setPayload', payload: initialState });
            });
        }
    }
    
    const mqttPublish = (context) => {
        if (state.client) {
            const { topic, qos, payload } = context;
            state.client.publish(topic, payload, { qos }, error => {
                if (error) {
                    console.log('Publish error: ', error);
                }
            });
        }
    }
    
    const mqttSub = (subscription) => {
        if (state.client) {
            subscription.forEach(({topic, qos}) => {
                state.client.subscribe(topic, { qos }, (error) => {
                    if (error) {
                        console.log('Subscribe to topics error', error)
                        return
                    }
                    dispatch({ type: 'setIsSub', payload: true });
                    console.log(`Se suscribió al topico: ${topic}`)
                });
            });
        }
    };
    
    const mqttUnSub = (subscription) => {
        if (state.client) {
            subscription.forEach(({topic}) => {
                state.client.unsubscribe(topic, error => {
                    if (error) {
                        console.log('Unsubscribe error', error)
                        return
                    }
                    dispatch({ type: 'setIsSub', payload: false });
                });
            })
        }
    };

    return (
        <SocketContext.Provider value={{ stateSocket: state, mqttConnect, mqttDisconnect, mqttPublish, mqttSub, mqttUnSub }}>
            { props.children }
        </SocketContext.Provider>
    );
}